<template>
  <div class="rental-page">
    <breadcrumb :breadcrumbs="breadcrumbs" />
    <header-banner title="デモ機貸出し方法" />

    <!-- ヒーロー -->
    <div class="rental-hero">
      <p class="rental-hero__text">
        レンタル費用<span class="rental-hero__price">0円！</span> 設置工事<span
          class="rental-hero__free"
          >不要！</span
        >
      </p>
    </div>

    <!-- お悩みセクション -->
    <div class="rental-worries">
      <h2 class="rental-worries__heading">
        こういったお悩みの方はぜひお問い合わせください！！
      </h2>
      <div class="rental-worries__circles">
        <div class="rental-worry-circle">
          <span>電波が届くのか<br class="pc-only" />心配</span>
        </div>
        <div class="rental-worry-circle">
          <span>購入前に<br class="pc-only" />試したい</span>
        </div>
        <div class="rental-worry-circle">
          <span>自分たちの用途に合うのか確認したい</span>
        </div>
      </div>
    </div>

    <!-- CTAボタン -->
    <div class="rental-cta-wrap">
      <p class="rental-cta-wrap__lead">まずはお気軽にご相談ください</p>
      <div class="rental-cta">
        <router-link
          to="/contact"
          class="rental-cta__btn rental-cta__btn--contact"
        >
          <span class="rental-cta__btn-inner">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"
              />
            </svg>
            <span class="rental-cta__btn-text">
              <span class="rental-cta__btn-sub">デモ機貸し出しについて</span>
              <span class="rental-cta__btn-main">フォームで問い合わせる</span>
            </span>
          </span>
        </router-link>
        <div class="rental-cta__divider">or</div>
        <a href="tel:076-294-4440" class="rental-cta__btn rental-cta__btn--tel">
          <span class="rental-cta__btn-inner">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path
                d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56-.35-.12-.74-.03-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z"
              />
            </svg>
            <span class="rental-cta__btn-text">
              <span class="rental-cta__btn-sub">お急ぎの方はお電話で</span>
              <span class="rental-cta__btn-main">076-294-4440</span>
            </span>
          </span>
        </a>
      </div>
    </div>

    <!-- 貸出し条件 -->
    <div class="rental-conditions">
      <h2 class="rental-section-heading">デモ機貸し出し条件</h2>
      <ul class="rental-conditions__list">
        <li>貸出し期間はデモ機の到着から1週間となります。</li>
        <li>在庫状況により貸出し開始までお待ちいただく場合があります。</li>
        <li>ご返却送料のみお客様のご負担となります。</li>
        <li>
          返却された貸出し品に破損や欠品が生じた場合は、修理代等をご負担いただく場合があります。
        </li>
        <li>
          デモ機の使用にて生じたお客様への損害等は、いかなる場合でも弊社では責任を負いません。
        </li>
      </ul>
    </div>

    <!-- よくある質問 -->
    <div class="rental-faq">
      <h2 class="rental-section-heading">デモ機の貸出についてのよくある質問</h2>
      <question-and-answer
        :number="1"
        :question="'デモ機の貸出期間はどれくらいですか？'"
        :answer="'デモ機の到着から1週間となります。'"
      />
      <question-and-answer
        :number="2"
        :question="'費用はかかりますか？'"
        :answer="
          'レンタル費用は無料です。ご返却の際の送料のみお客様のご負担となります。'
        "
      />
      <question-and-answer
        :number="3"
        :question="'どの商品でも貸し出しできますか？'"
        :answer="
          '在庫状況によりご希望の商品をご用意できない場合がございます。まずはお気軽にお問い合わせください。'
        "
      />
    </div>
  </div>
</template>

<script>
import HeaderBanner from '@/components/modules/HeaderBanner'
import Breadcrumb from '@/components/modules/Breadcrumb'
import QuestionAndAnswer from '@/components/modules/QuestionAndAnswer'

export default {
  components: {
    HeaderBanner,
    Breadcrumb,
    QuestionAndAnswer,
  },
  title: 'デモ機無料貸出し｜B-Call（ビーコール）',
  meta:
    'リモートリプライコール、リプライコール、リプライコールPC、エコチャイム、コココールファクトインコールのデモ機貸出しは、呼出しチャイム・呼出しシステムの専門店ビーコールにお任せください。',
  computed: {
    breadcrumbs: function() {
      return {
        data: [
          { name: '呼び出しベルのB-Call', path: 'https://b-call.jp/' },
          { name: 'デモ機貸出し方法', path: 'https://b-call.jp/rental' },
        ],
      }
    },
  },
}
</script>

<style scoped>
.rental-page {
  width: 100%;
}

/* ヒーロー */
.rental-hero {
  text-align: center;
  padding: 2.5rem 1rem 2rem;
  background: #fffbf5;
}

.rental-hero__text {
  font-size: 1.6rem;
  font-weight: bold;
  margin: 0;
  line-height: 2.2;
  color: #555;
}

.rental-hero__price {
  color: #e67e22;
  font-size: 2.8rem;
  margin: 0 0.05em;
  padding-bottom: 2px;
  border-bottom: 4px solid rgba(230, 126, 34, 0.3);
}

.rental-hero__free {
  color: #e60044;
  font-size: 2.8rem;
  margin: 0 0.05em;
  padding-bottom: 2px;
  border-bottom: 4px solid rgba(230, 0, 68, 0.3);
}

/* お悩みセクション */
.rental-worries {
  max-width: 960px;
  margin: 1rem auto 0;
  padding: 1.5rem 2rem 0;
  text-align: center;
}

.rental-worries__heading {
  font-size: 1.3rem;
  font-weight: bold;
  margin-bottom: 2rem;
  color: #4d4d4d;
}

.rental-worries__circles {
  display: flex;
  justify-content: center;
  gap: 40px;
  flex-wrap: wrap;
}

.rental-worry-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 160px;
  height: 160px;
  border-radius: 50%;
  background: #5bb8c8;
  color: white;
  font-size: 1.02rem;
  font-weight: bold;
  text-align: center;
  line-height: 1.6;
  padding: 20px;
  box-sizing: border-box;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
}

/* CTAセクション */
.rental-cta-wrap {
  background: #eef4fb;
  padding: 2rem 1rem 2.5rem;
  margin: 2rem 0;
  text-align: center;
}

.rental-cta-wrap__lead {
  font-size: 1rem;
  color: rgb(26, 87, 167);
  font-weight: bold;
  letter-spacing: 2px;
  margin: 0 0 1.2rem;
}

.rental-cta {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 860px;
  margin: 0 auto;
  gap: 0;
}

.rental-cta__divider {
  font-size: 0.9rem;
  font-weight: bold;
  color: #888;
  padding: 0 1rem;
  flex-shrink: 0;
}

.rental-cta__btn {
  flex: 1;
  max-width: 440px;
  display: block;
  text-decoration: none;
  color: white;
  border-radius: 6px;
  box-shadow: 0 4px 0 rgba(0, 0, 0, 0.2);
  transition: opacity 0.3s, transform 0.1s, box-shadow 0.1s;
}

.rental-cta__btn:hover {
  opacity: 0.7;
}

.rental-cta__btn-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 1.2rem 2rem;
  white-space: nowrap;
}

.rental-cta__btn svg {
  width: 28px;
  height: 28px;
  fill: white;
  flex-shrink: 0;
}

.rental-cta__btn-text {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.rental-cta__btn-sub {
  font-size: 0.75rem;
  opacity: 0.85;
  letter-spacing: 0.5px;
}

.rental-cta__btn-main {
  font-size: 1.1rem;
  font-weight: bold;
  letter-spacing: 1px;
}

.rental-cta__btn--contact {
  background: #e67e22;
  border-bottom: 4px solid #b8611a;
}

.rental-cta__btn--tel {
  background: rgb(26, 87, 167);
  border-bottom: 4px solid rgb(15, 58, 120);
}

/* 貸出し条件 */
.rental-conditions {
  max-width: 800px;
  margin: 0 auto 1rem;
  padding: 0 1rem;
}

.rental-section-heading {
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
  color: rgb(26, 87, 167);
  margin: 2.5rem 0 1.5rem;
}

.rental-conditions__list {
  list-style: none;
  padding: 1.2rem 1.5rem;
  margin: 0;
  background: #f9fafb;
  border-radius: 6px;
}

.rental-conditions__list li {
  padding: 0.5rem 0 0.5rem 1.2em;
  text-indent: -1.2em;
  line-height: 1.8;
  color: #4d4d4d;
  font-size: 0.95rem;
}

.rental-conditions__list li::before {
  content: '▸ ';
  color: rgb(26, 87, 167);
}

/* よくある質問 */
.rental-faq {
  max-width: 800px;
  margin: 0 auto 3rem;
  padding: 0 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.rental-faq .rental-section-heading {
  width: 100%;
}

/* レスポンシブ */
@media only screen and (max-width: 600px) {
  .pc-only {
    display: none;
  }

  .rental-hero {
    padding: 1.5rem 0.5rem 1.2rem;
  }

  .rental-hero__text {
    font-size: 1rem;
    display: flex;
    align-items: center;
    gap: 0.3rem;
    line-height: 1.8;
  }

  .rental-hero__price,
  .rental-hero__free {
    font-size: 1.6rem;
  }

  .rental-worry-circle {
    width: 120px;
    height: 120px;
    font-size: 0.82rem;
  }

  .rental-worries__circles {
    gap: 20px;
  }

  .rental-cta {
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  .rental-cta__divider {
    padding: 0;
  }

  .rental-cta__btn {
    max-width: 100%;
    width: 100%;
  }

  .rental-cta__btn-main {
    font-size: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Rental.vue